<div class="policy bg-light" id="policy_top">
    <div class="policy__container" [style.height.px]="appAlert.windowHeight - 200">
        <div class="policy_header">
            <h1>PRIVACY  POLICY </h1>
            <h1>OF  EMODUL  MOBILE  APPLICATION </h1>
        </div>
        <div class="row"></div>
        <div class="policy_navigation_menu">
            1. <a class="link" (click)="appAlert.scrollTo('Introduction')">Introduction</a>
            <br />
            2. <a class="link" (click)="appAlert.scrollTo('ContractDetails')">Information about eModul & Contract details</a>
            <br />
            3. <a class="link" (click)="appAlert.scrollTo('AboutEModul')">About eModul</a>
            <br />
            4. <a class="link" (click)="appAlert.scrollTo('AboutPolicy')">About the policy</a>
            <br />
            5. <a class="link" (click)="appAlert.scrollTo('DataCollection')">Type of data & how we collect it</a>
            <br />
            6. <a class="link" (click)="appAlert.scrollTo('DataUsage')">How we use Your data</a>
            <br />
            7. <a class="link" (click)="appAlert.scrollTo('YourRights')">Your rights concerning data collection</a>
            <br />
            8. <a class="link" (click)="appAlert.scrollTo('StoringData')">Storing data</a>
            <br />
            9. <a class="link" (click)="appAlert.scrollTo('SharingData')">Sharing data & transfering data to the third countries</a>
        </div>
        <div class="policy_body>">
            <div class="policy_paragraph">
                <h1 id="Introduction">1. INTRODUCTION</h1>
                <p class="content">
                    Thank you for choosing the eModul app! We strive to ensure that eModul meets all your expectations. That is why one of our top priorities is
                    your privacy and the security of the data you provide us with. For this purpose, we have established a document that we have named the Privacy Policy
                    of the eModul Mobile Application. We kindly ask you to read the Policy carefully before using eModul
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="ContractDetails">2. INFORMATION ABOUT EMODUL  ADMINISTRATOR  &  CONTACT DETAILS </h1>
                <p class="content">
                    eModul is an application developed and administered by TECH STEROWNIKI spółka z ograniczoną odpowiedzialnością,  spółka komandytowa
                    (limited liability company, limited partnership), with registered office in Wieprz ul. Biała Droga 31, 34-122, NIP: (VAT identification number)
                    551 23 60 632, REGON: (National Business Registry Number) 356782780, KRS: (National Court Register) 0000594881.
                    Use the details below to contact us in any matter which is important to you:
                </p>
                <table class="policy_contact_details_table">
                    <tr>
                        <td>e-mail</td>
                        <td>poczta&#64;techsterowniki.pl </td>
                    </tr>
                    <tr class="separating_line">
                        <td>letter</td>
                        <td>ul. Biała Droga 31, 34-122 Wieprz </td>
                    </tr>
                    <tr class="separating_line">
                        <td>phone </td>
                        <td>+48 33 330 00 07 </td>
                    </tr>
                </table>
            </div>

            <div class="policy_paragraph">
                <h1 id="AboutEModul">3. ABOUT EMODUL </h1>
                <p class="content">
                    eModul application is dedicated for controllers cooperating with ST-505 or WiFi module family. eModul enables you to:
                </p>
                <ul class="pp_list">
                    <li>view and edit current controller parameters</li>
                    <li>view the temperature history and alarm log</li>
                    <li>control many modules using one account; </li>
                    <li>receive email notification about current alarms </li>
                </ul>
            </div>

            <div class="policy_paragraph">
                <p class="content">
                    Using eModul is free of charge, but requires the controllers cooperating with the modules mentioned above. All data you provide us is necessary
                    for the proper functioning of eModul, for statistical purposes and objectives related to the improvement of eModul. eModul is intended for people
                    above the age of 13.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="AboutPolicy">4. ABOUT THE POLICY</h1>
                <p class="content">
                    The Policy contains all the necessary information that determine our relations regarding the information you provide us with. Thus,
                    the basic purpose of the Policy is to ensure that:
                </p>
                <ul class="pp_list">
                    <li>at every stage of our cooperation you know what data we collect, what we do with it and what you are entitled to in this respect; </li>
                    <li>your consent to provide the data is informed and voluntary</li>
                </ul>
            </div>

            <div class="policy_paragraph">
                <p class="content">
                    We are constantly developing and improving eModul. Therefore, if we make changes to the application that will affect the scope of collection and processing
                    of data provided by you, we will provide you with additional information, terms and conditions. If the new scope of collection and processing does not comply
                    with your preferences, you will always be able to withdraw your consent, which may, however, involve deactivation of eModul on your device.
                </p>
            </div>

            <div class="policy_paragraph">
                <p class="content">
                    Despite no changes in eModul, we may change the Policy itself periodically. In the event of such changes, we will inform you about them in a clear and
                    unambiguous manner (e.g. by email). Any changes to the Policy will enter into force at a time that will allow you to decide freely whether you still want to use
                    eModul despite the implemented changes.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="DataCollection">5. TYPE OF DATA  &  HOW WE COLLECT IT </h1>
                <p class="content">
                    Below you may find specific type of data we collect at different stages of using eModul
                </p>
                <table class="policy_details_table">
                    <tr>
                        <th>Stage </th>
                        <th>Category </th>
                        <th>Description </th>
                    </tr>

                    <tr>
                        <td>Registration  </td>
                        <td>Registration data </td>
                        <td>
                            <p>These are all the data you provide while registering in eModul. We collect the data which you voluntarily provide in eModul app</p>
                            <p>At this stage we collect your e-mail address to verify your account.  </p>
                        </td>
                    </tr>

                    <tr>
                        <td>Module registration   </td>
                        <td>Detailed registration data  </td>
                        <td>
                            <p>These are all the data you provide while registering a new module. We collect the data which you voluntarily provide in eModul app. </p>
                            <p>At this stage we collect your e-mail address to send you notifications (it may be the same as in registration process), phone number to send you notifications</p>
                            <p>While registering a module you may provide some additional data which will help us customise your eModul account. In particular, we ask you to provide your
                                postcode and country, but the data is not necessary to complete the advanced registration process. </p>
                        </td>
                    </tr>
                    <tr>
                        <td>Using eModul  </td>
                        <td>Usage data  </td>
                        <td>
                            <p>These are all data that we obtain from you in an automated way, while you are using eModul</p>
                            <p>At this stage we collect the following data: name of the device, a unique device token (used for notification purposes), device software version, country of eModul
                                installation and information about any errors which occur in eModul. </p>
                            <p>eModul in a browser-based version uses cookies only to keep you logged in (maintain session state).
                            </p>
                        </td>
                    </tr>
                </table>
            </div>

            <div class="policy_paragraph">
                <p class="content">
                    All data collected by us, which are provided by you in the module registration process, are provided voluntarily. The data collected automatically allows us to improve eModul.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="DataUsage">6. HOW WE USE YOUR DATA </h1>
                <p class="content">
                    Below we have listed the ways in which we use the data collected from you
                </p>
                <table class="policy_details_table">
                    <tr>
                        <th>Category </th>
                        <th>Basis  </th>
                        <th>Reasons for processing data  </th>
                    </tr>

                    <tr>
                        <td>Registration data </td>
                        <td>Performance of the agreement  </td>
                        <td>
                            These data are necessary for the performance of the agreement concluded with you and your logging in eModul.
                            This agreement concerns the creation of an account in eModul where you can register the controller
                        </td>
                    </tr>
                    <tr>
                        <td>Advanced registration data </td>
                        <td>Performance of the agreement  </td>
                        <td>
                            These data are necessary for the performance of the agreement concluded with you and your logging in eModul.
                            This agreement concerns making available eModul functionalities described in point 3 of this Policy
                        </td>
                    </tr>
                    <tr>
                        <td>Advanced registration data </td>
                        <td>Performance of the agreement  </td>
                        <td>
                            These data are necessary to communicate with you in connection with alarms appearing in the modules
                        </td>
                    </tr>

                    <tr>
                        <td>Advanced registration data </td>
                        <td>Your consent  </td>
                        <td>
                            In advanced registration you can provide us with additional data, including postcode and country.
                            We use the data for statistical purposes and for purposes related to the improvement of eModul functioning
                        </td>
                    </tr>

                    <tr>
                        <td>Usage data </td>
                        <td>Performance of the agreement <br/> Legitimate interests </td>
                        <td>
                            We use the data for statistical purposes and for purposes related to the improvement of eModul functioning
                        </td>
                    </tr>
                </table>
            </div>

            <div class="policy_paragraph">
                <p class="content">
                    We never use the data obtained from you to make decisions automatically, including profiling, if the decision may cause legal effects for you or have a similar effect.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="YourRights">7. YOUR RIGHTS CONCERNING DATA COLLECTION </h1>
                <p class="content">
                    Due to the fact that you provide us with your data, including personal details, you have a number of rights. Remember that you are entitled to:
                </p>
                <table class="policy_details_table_no_header">
                    <tr>
                        <td>The right to access </td>
                        <td>The right to be informed and to request access to the data processed by us. </td>
                    </tr>
                    <tr>
                        <td>The right to amend </td>
                        <td>The right to request correction or update the data if it is inaccurate or incomplete </td>
                    </tr>
                    <tr>
                        <td>The right to delete </td>
                        <td>The right to request that your data are deleted</td>
                    </tr>

                    <tr>
                        <td>The right to restrict </td>
                        <td>The right to request that we stop processing all or part of your data temporarily or permanently. </td>
                    </tr>

                    <tr>
                        <td>The right to object </td>
                        <td>The right to object, at any time, to our processing of your data for reasons relating to specific situations. </td>
                    </tr>
                    <tr>
                        <td>The right to transfer </td>
                        <td>The right to request an electronic copy of the data or to transfer it to be used by third parties.  </td>
                    </tr>
                    <tr>
                        <td>The right to complain  </td>
                        <td>The right to make a complaint about the processing of personal data to the supervisory authority, which in Poland is the President of the Office for Personal Data Protection (PUODO). </td>
                    </tr>
                </table>
                <p>
                    You can exercise all the above mentioned rights by contacting us using the details provided in point 2 of the Policy.
                </p>
            </div>
            <div class="policy_paragraph">
                <h1 id="StoringData">8. STORING DATA </h1>
                <p class="content">
                    We store your data, which we process in connection with the contract and legitimate interests, as long as it is necessary to enable you to use of eModul and,
                    for legitimate and necessary purposes, fulfil legal obligations and resolve conflicts. Your data will be stored for as long as you use eModul, which is why
                    we understand if you request us to delete your account. After you stop using eModul, your data will be stored by us during the claim prescription period.
                </p>
            </div>

            <div class="policy_paragraph">
                <p class="content">
                    We store your data which we process on the basis of your free consent for as long as you do not withdraw your consent. To withdraw your consent, use the eModul
                    functionality or report your intention to delete your account.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="SharingData">9. SHARING DATA & TRANSFERRING DATA TO THE THIRD COUNTRIES </h1>
                <p class="content">
                    Your data may be shared only when it is permitted by the law. At the moment, we anticipate sharing these data only on the basis of a contract for entrusting data processing to:
                </p>
                <ul class="pp_list">
                    <li>handle IT infrastructure and IT systems; </li>
                    <li>subcontractors helping us to execute our obligations. </li>
                </ul>
            </div>
            <div class="policy_paragraph">
                <p class="content">
                    Your data are not sent to countries outside the European Economic Area.
                </p>
            </div>
        </div>
    </div>
    <div class="policy__buttons-box">
        <input type="button"
               [value]="subtitles.setSubtitle(1744)"
               class="app-alert__button  bg-ok color-light font-bold font-14 cursor-pointer"
               (click)="appAlert.closePolicy()">
    </div>
</div>
